module.exports = __webpack_public_path__ + "02_face.66a0ac93.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/02_face.png
// module id = QMl8
// module chunks = 0